/* Founder video (checklist item 80; loading rewritten 19 Aug for #83).

   Bianca's ask: "can you build it out so the video buffers... it doesn't have
   to load the whole thing as someone enters our website... allows people to
   load our page instantly."

   The page was already never waiting on it - preload="none" plus a data-src
   with no src means the browser has no URL to fetch until this file hands it
   one, and that happens after window load. What this rewrite fixes is what
   happens AFTER the page is up, which is where the bytes actually were:

   1. A TEASER WINDOW. Item 158 (8 Sept) RETIRED IT. Bianca: "the video just
      plays the whole time, because if someone's on that page they're gonna
      see that that video is playing. They might keep scrolling all the way to
      the bottom and then decide, hey, I'm gonna watch that video." A card
      that stops twelve seconds in is a card that is not playing by the time
      most people look at it, and the whole point of the element is presence.
      So TEASER is now Infinity and the silent card loops the entire film.
      The window is left implemented, not deleted: set TEASER back to a number
      and the old behaviour returns, because the browser fetches roughly what
      it plays and that is still the lever if the file ever gets long.
      (The first plan was to serve a small rendition to the small card and a
      sharp one on click. Probed on the live draft: Shopify hands the theme
      exactly one mp4, so there was nothing to switch between.)
   2. A LOOP BUDGET. The silent loop gets roughly LOOP_BUDGET seconds in total
      and then rests on the play button, so a tab left open all afternoon is
      not still spinning a video all afternoon.
   3. BACKGROUND TABS PAUSE. Nothing streams into a tab nobody is looking at.
   4. METERED AND SLOW CONNECTIONS FETCH NOTHING. Save-Data, 2g or 3g gets the
      cover image and a play button, and the visitor decides.
   5. Reduced-motion gets the same treatment as 4, for the same reason: do not
      start something the person did not ask for.

   Also: opening always restarts from zero, so nobody lands in the middle of
   the sentence, and dismissal is remembered for the session only. */
(function () {
  var root = document.querySelector('[data-wn-fv]');
  if (!root) return;

  var KEY = 'wn-fv-dismissed';
  try { if (sessionStorage.getItem(KEY) === '1') return; } catch (e) {}

  var card = root.querySelector('[data-wn-fv-card]');
  var video = root.querySelector('[data-wn-fv-video]');
  var source = video && video.querySelector('source[data-src]');
  var openBtn = root.querySelector('[data-wn-fv-open]');
  var closeBtn = root.querySelector('[data-wn-fv-close]');
  var scrim = root.querySelector('[data-wn-fv-scrim]');
  if (!card || !video || !source) return;

  // Named SRC, not URL: URL is a browser global and shadowing it inside this
  // closure is the kind of thing that bites someone six months from now.
  var SRC = source.getAttribute('data-src');
  if (!SRC) return;

  /* How much of the film the silent card is allowed to pull down. Infinity
     since item 158 (8 Sept): the whole film loops silently, so somebody who
     scrolls the page and comes back to the card still finds it playing.
     Setting this to a number caps it again - the browser fetches roughly what
     it plays, so a number here is a direct saving on every visitor's data
     bill, at the cost of the card sitting still for most of their visit. */
  var TEASER = Infinity;

  /* Total seconds of silent playback before the card rests on the play
     button. Was 45. Item 148 (7 Sept), Bianca: keep it playing on loop
     silently unless they click on it, so someone who missed the start can
     come back to it. Infinity means the silent teaser never rests; it costs
     no extra data because the teaser is cached after the first pass. Closing
     the card with the X still removes it for the rest of the visit. */
  var LOOP_BUDGET = Infinity;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var slow = (conn && conn.effectiveType) || '';
  // Written out rather than as a regex on purpose: a backslash in this file
  // has to survive being posted through the theme API, and it did not.
  var frugal = !!(conn && (conn.saveData || slow === 'slow-2g' || slow === '2g' || slow === '3g'));
  /* Item 148 (7 Sept): reduced-motion no longer holds the silent loop back.
     Bianca's own Mac has Reduce Motion on, so she saw a still with a play
     button and read it as the video being gone; her call is that the card
     plays for everyone. Data-saver and slow connections still get the still,
     because that is about bytes, not taste. The reduced flag above is left
     in place, unused, so this decision is easy to reverse. */
  var holdBack = frugal;

  var loaded = false;
  var played = 0;          // seconds of silent playback spent so far
  var teaserEnd = TEASER;
  var spent = false;
  var pausedByHiding = false;
  var lastFocus = null;

  function markPaused() { root.classList.toggle('is-paused', video.paused); }

  function play() {
    var p = video.play();
    if (p && p.catch) p.catch(function () { markPaused(); });
  }

  function load(thenPlay) {
    if (!loaded) {
      source.src = SRC;
      video.load();          // resets currentTime to 0 by itself
      loaded = true;
    }
    if (thenPlay) play();
  }

  video.addEventListener('loadedmetadata', function () {
    if (video.duration && isFinite(video.duration) && video.duration > 0) {
      teaserEnd = Math.min(TEASER, video.duration);
    }
  });

  function isOpen() { return root.classList.contains('is-open'); }

  function rewind() {
    try { video.currentTime = 0; } catch (e) {}
  }

  // The silent loop. Kept here rather than on the loop attribute so the
  // teaser cap above is still possible: with TEASER at Infinity, teaserEnd is
  // the film's own duration and this simply never fires, and the ended
  // handler below does the looping instead.
  video.addEventListener('timeupdate', function () {
    if (isOpen() || video.paused) return;
    if (video.currentTime < teaserEnd) return;
    played += teaserEnd;
    if (played < LOOP_BUDGET) rewind();
    else { spent = true; video.pause(); }
  });

  // A film shorter than the teaser window reaches the end on its own.
  video.addEventListener('ended', function () {
    if (isOpen()) { markPaused(); return; }
    played += video.duration || 0;   // never Infinity: that would spend the budget in one loop
    if (played < LOOP_BUDGET) { rewind(); play(); }
    else { spent = true; markPaused(); }
  });

  video.addEventListener('play', markPaused);
  video.addEventListener('pause', markPaused);

  function whenIdle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2600 });
    else setTimeout(fn, 1400);
  }

  function reveal() {
    // Revealed only once the page has finished loading, which also guarantees
    // the non-blocking stylesheet has arrived, so there is no unstyled flash.
    root.hidden = false;
    markPaused();
    if (holdBack) return;                       // cover image, play button, no bytes
    whenIdle(function () { load(true); });
  }

  /* Item 149, the 7 Sept phone walkthrough. On a 375px screen the card is
     fixed over the bottom 165px of the first view, which on the home page is
     exactly where the hero's two links sit - Engagement rings and Ready to
     ship - so the first thing a phone visitor meets is a video sitting on the
     two things we want them to tap. Shrinking the card further would cost the
     presence Bianca asked for, so on phones the reveal simply waits until
     they have scrolled past the hero. Desktop is untouched: at 750px and up
     the card still appears on load, where it sits in the margin and covers
     nothing. The gate wraps the whole reveal rather than the hidden attribute
     alone, so the source assignment and the autoplay still happen at the same
     moment relative to the card appearing, just later. */
  function boot() {
    if (window.innerWidth >= 750) { reveal(); return; }
    var onScroll = function () {
      if (window.scrollY <= window.innerHeight * 0.6) return;
      window.removeEventListener('scroll', onScroll);
      reveal();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();   // a reload can restore the page already past the hero
  }
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot, { once: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (!video.paused) { pausedByHiding = true; video.pause(); }
    } else if (pausedByHiding) {
      pausedByHiding = false;
      if (!spent || isOpen()) play();
    }
    markPaused();
  });

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    video.muted = false;
    video.controls = true;
    // From here on the whole film is fair game - they asked for it.
    load(false);
    rewind();
    play();
    if (closeBtn) closeBtn.focus();
  }

  function collapse() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    video.muted = true;
    video.controls = false;
    // The opening is cached now, so a few more silent loops cost nothing.
    played = 0;
    spent = false;
    if (!holdBack) { rewind(); play(); }
    markPaused();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function dismiss() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    try { video.pause(); } catch (e) {}
    root.hidden = true;
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }

  if (openBtn) {
    openBtn.addEventListener('click', function () {
      if (isOpen()) return;   // let the controls work
      open();
    });
  }

  // The X collapses an open video first, and only dismisses from collapsed -
  // so it never feels like one stray click threw the whole thing away.
  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isOpen()) collapse();
      else dismiss();
    });
  }

  if (scrim) scrim.addEventListener('click', collapse);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) collapse();
  });
})();